import supabase from '@/utils/supabase';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export default function Lobby() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        const fetchAndRoute = async () => {
          const { data, error } = await supabase
            .from('profile')
            .select('role, client_id')
            .eq('id', session.user.id)
            .single();
          if (error) {
            console.error('Error fetching profile:', error.message);
            setStatus('error');
          } else if (data.role === 'client' && data.client_id !== null) {
            navigate('/client/');
          } else if (data.role === 'team') {
            navigate('/team/');
          } else if (data.role === 'owner') {
            navigate('/engine/');
          } else {
            setStatus('waiting');
          }
        };
        fetchAndRoute();
      } else {
        navigate('/login/');
      }
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Card className="flex flex-col items-center justify-center w-150 h-100">
        <CardContent>
          {status === 'loading' && <p className="text-2xl">Loading...</p>}
          {status === 'error' && (
            <p className="text-2xl">Something went wrong. Please try again.</p>
          )}
          {status === 'waiting' && (
            <div className="flex flex-col items-center gap-10">
              <p className="text-2xl">Waiting for your account setup...</p>
              <Button
                size={'lg'}
                className="text-lg px-10"
                onClick={() => window.location.reload()}
              >
                Refresh
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
